module.exports = __webpack_public_path__ + "static/media/guide_bg.19523d90.jpg";